module.exports = __webpack_public_path__ + "ck.0e4eaabf.svg";